import React from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";

const BookingUpdatearrivalmodal = ({ isOpen, onClose }) => {
  return (
    <Modal
      className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalBody className="custom-modal">
        <div className="flex flex-col items-center justify-center py-8">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
            Allotment Pending
          </h2>

          <p className="mt-3 text-sm text-center text-gray-600 dark:text-gray-300 max-w-md leading-6">
            The required allotment for this booking has not been completed yet.
            Please complete all necessary allotments before proceeding.
          </p>

          <div className="mt-6">
            <Button
              layout="outline"
              className="w-20 h-8 text-sm"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BookingUpdatearrivalmodal;
